import { zCatalogRecord } from "src/business/records/ZCatalogRecord";
import type { ZCatalogRecordSafe } from "src/business/records/ZCatalogRecordSafe";
import { zSidLabel } from "src/types/ZSidLabel";
import z from "zod";

const zWorkflowStep = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string().nullish(),
});

const zWorkflowCardExtra = z.object({
  workflowStep: zWorkflowStep.nullish(),
  workflowId: z.string().nullish(),
  originalCard: zSidLabel.nullish(),
});

export const zWorkflowCard = zCatalogRecord.and(zWorkflowCardExtra);
export type ZWorkflowCard = z.infer<typeof zWorkflowCard>;

// ZWorkflowCardSafe — ZWorkflowCard с типизированным data (после makeCatalogRecordSafe).
// Определяется как тип, а не Zod-схема, т.к. парсинг идёт через zWorkflowCard
// с последующей ручной трансформацией через makeCatalogRecordSafe.
export type ZWorkflowCardSafe = Omit<ZWorkflowCard, "data"> & {
  data: ZCatalogRecordSafe["data"];
};

export type WorkflowCardsFilter = { text?: string };
